import React from "react";
import PainelTV from "../pages/Producao/PainelTV";

import CameraIcon from '../assets/svg/camera.svg';
import EmptyPage from "../pages/Empty";
import roboticArmIcon from "../assets/svg/roboticArm.svg";
import PainelTVProducaoSolTipler from "../pages/Producao/PainelTVProducao";
import PainelTV1 from "../pages/Producao/PainelTV1";
import PainelTVSLA from "../pages/Producao/PainelTVSLA";
import PainelTVLogo from "../pages/Producao/PainelTVLogo";
import PainelTVProducaoMensal from "../pages/Producao/PainelTVProducaoMensal";
import PainelTVMetasMes from "../pages/Producao/PainelTVMetasMes";
import PainelTVBandas from "../pages/Producao/PainelTVBandas";
import PainelTVOperadores from "../pages/Producao/PainelTVOperadores";

const mainPaineisRoutes = [

    { path: "/pc/tv", name: "Pneus na linha", svgIconFile: CameraIcon, iconStyle: { width: '35px', height: '35px' } ,component: PainelTV, type : ""    , secgroup: 1000 },
    { path: "/pc/p1", name: "Pneus na linha", svgIconFile: CameraIcon, iconStyle: { width: '35px', height: '35px' } ,component: PainelTV1, type : ""    , secgroup: 1000 },
    { path: "/pc/p2", name: "Producao & estoque", svgIconFile: roboticArmIcon, iconStyle: {width: '35px', height: '35px' } , component: PainelTVProducaoSolTipler, type : "", secgroup: 1103 },
    { path: "/pc/p3", name: "Producao mensal", svgIconFile: roboticArmIcon, iconStyle: {width: '35px', height: '35px' } , component: PainelTVProducaoMensal, type : "", secgroup: 1103 },
    { path: "/pc/p4", name: "Producao mensal - Bandas", svgIconFile: roboticArmIcon, iconStyle: {width: '35px', height: '35px' } , component: PainelTVBandas, type : "noRoot", secgroup: 1103 },
    { path: "/pc/p5", name: "Metas", svgIconFile: roboticArmIcon, iconStyle: {width: '35px', height: '35px' } , component: PainelTVMetasMes, type : "", secgroup: 1103 },
    { path: "/pc/p6", name: "SLA", svgIconFile: roboticArmIcon, iconStyle: {width: '35px', height: '35px' } , component: PainelTVSLA, type : "", secgroup: 1103 },
    { path: "/pc/p7", name: "Logo", svgIconFile: roboticArmIcon, iconStyle: {width: '35px', height: '35px' } , component: PainelTVLogo, type : "", secgroup: 1103 },
    { path: "/pc/p8", name: "Operadores", svgIconFile: roboticArmIcon, iconStyle: {width: '35px', height: '35px' } , component: PainelTVOperadores, type : "", secgroup: 1103 },

    // { path: "/", name: "", icon: "assignment", component: EmptyPage , type : "noRoot", routeParam: "exact", secgroup: 2 },

];

export default mainPaineisRoutes;

